import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { tableBatchData } from "Pages/Admin/GlobalExecution/@signals"
import { useBatchBackendApiPath } from "Pages/Admin/GlobalExecution/Batches/@hooks"


export default function useGlobalBatchMultiple(selectedData, setSelectedRows) {
    const { showToast } = useToast()
    const { forceUrl, retryUrl } = useBatchBackendApiPath()


    const msg = selectedData.length > 1
        ? `these ${selectedData.length} Batches`
        : 'the selected batch'


    const handleStopMultipleExecutions = useCallback(() => {
        showToast.confirm(`Are you sure to stop ${msg}?`, {
            onSubmit: () => {
                showToast.promise(postSubmit(forceUrl, {
                    idBatch: selectedData.map(a => a.id_last_execution)
                }), {
                    onFinish: () => {
                        tableBatchData.value = tableBatchData.value.filter(e => !selectedData.map(a => a.id_last_execution).includes(e.id_last_execution))
                    }
                })
            }
        })
        setSelectedRows([])
    }, [JSON.stringify(selectedData)])


    const handleRetryMultipleExecutions = useCallback(() => {
        const password = window.prompt('Enter password to retry executions:')
        if (password === null) return

        showToast.confirm(`Are you sure to retry ${msg}?`, {
            onSubmit: () => {
                showToast.promise(postSubmit(retryUrl, {
                    idBatch: selectedData.map(a => a.id_last_execution),
                    password
                }))
            }
        })
        setSelectedRows([])
    }, [JSON.stringify(selectedData)])


    return {
        handleStopMultipleExecutions,
        handleRetryMultipleExecutions,
    }
}